interface Config {
  version: string;
  environment: 'production' | 'demo' | 'staging' | 'development';
  baseUrl: string;
  apiUrl: string;
  wsUrl: string;
  bffUrl: string;
  keycloak: {
    url: string;
    realm: string;
    clientId: string;
    enableLogging?: boolean;
    silentCheckSsoRedirectUri: string;
  };
  superset: {
    baseUrl: string;
  };
  heap: {
    enabled: boolean;
    appId: string;
  };
  sentry: {
    enabled: boolean;
    dsn: string;
  };
  unleash: {
    enabled: boolean;
    url: string;
    clientKey: string;
    appName: string;
    refreshInterval: number;
  };
  clarity: {
    projectId?: string;
  };
  piniaStoreKeyPrefix: string;
}

const env = import.meta.env;

export const config: Config = {
  version: env.ONEBEAT_APP_VERSION,
  environment: env.ONEBEAT_APP_ENVIRONMENT,
  baseUrl: '/',
  apiUrl: env.ONEBEAT_APP_API_URL,
  wsUrl: env.ONEBEAT_APP_WS_URL,
  bffUrl: env.ONEBEAT_APP_BFF_URL,
  keycloak: {
    url: env.ONEBEAT_APP_KEYCLOAK_URL,
    realm: env.ONEBEAT_APP_KEYCLOAK_REALM,
    clientId: env.ONEBEAT_APP_KEYCLOAK_CLIENT_ID,
    enableLogging: __DEV__,
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
  },
  superset: {
    baseUrl: env.ONEBEAT_APP_SUPERSET_BASE_URL,
  },
  heap: {
    enabled: !!env.ONEBEAT_APP_HEAP_APP_ID,
    appId: env.ONEBEAT_APP_HEAP_APP_ID,
  },
  sentry: {
    enabled: !!env.ONEBEAT_APP_SENTRY_DSN,
    dsn: env.ONEBEAT_APP_SENTRY_DSN,
  },
  clarity: {
    projectId: env.ONEBEAT_APP_CLARITY_PROJECT_ID,
  },
  unleash: {
    enabled: !!(env.ONEBEAT_APP_UNLEASH_URL && env.ONEBEAT_APP_UNLEASH_CLIENT_KEY),
    url: env.ONEBEAT_APP_UNLEASH_URL,
    clientKey: env.ONEBEAT_APP_UNLEASH_CLIENT_KEY,
    appName: 'onebeat-app',
    refreshInterval: 30,
  },
  piniaStoreKeyPrefix: 'onebeat:',
};
